// NavigationHistoryContext.js
import { createContext, useContext, useState, useRef } from 'react';

const NavigationHistoryContext = createContext();
export const useNavHistory = () => useContext(NavigationHistoryContext);

export const NavigationHistoryProvider = ({ children }) => {
  const [stack, setStack] = useState([]);
  const stackRef = useRef(stack); // for direct read/write

  const syncStack = (newStack) => {
    stackRef.current = newStack;
    setStack(newStack);
  };

  const pushPage = (pathname, localstate) => {
    const newStack = [...stackRef.current, { pathname, localstate }];
    syncStack(newStack.slice(-100)); // keep only last 100
  };

  const popPage = () => {
    const updated = [...stackRef.current];
    const last = updated.pop();
    syncStack(updated);
    return last;
  };

  const getPrevious = () => stackRef.current[stackRef.current.length - 2] || null;

  return (
    <NavigationHistoryContext.Provider
      value={{ stack, pushPage, popPage, getPrevious }}
    >
      {children}
    </NavigationHistoryContext.Provider>
  );
};
